/**
 * Mobile Menu Toggle & Accordion
 * Handles hamburger menu interaction and vertical accordion for sub-menus
 */

document.addEventListener('DOMContentLoaded', function () {
    const hamburger = document.getElementById('hamburgerToggle');
    const closeBtn = document.getElementById('mobileMenuClose');
    const mobileMenuDrawer = document.getElementById('mobileMenuDrawer');
    const menuOverlay = document.getElementById('mobileMenuOverlay');
    const mobileNavMenu = document.querySelector('.mobile-nav-menu');

    const mobileMainLayer = document.getElementById('mobileMainLayer');
    const mobileSubmenuLayer = document.getElementById('mobileSubmenuLayer');
    const mobileSubSubmenuLayer = document.getElementById('mobileSubSubmenuLayer');
    const backBtn = document.getElementById('mobileSubMenuBack');
    const subSubBackBtn = document.getElementById('mobileSubSubMenuBack');
    const subSubContent = document.getElementById('mobileSubSubmenuContent');

    const fallbackServicesSubData = {
        'website-design': [
            { title: 'WordPress Web Design', link: '#' },
            { title: 'eCommerce Web Design', link: '#' },
            { title: 'Shopify Development', link: '#' },
            { title: 'Custom Web Design', link: '#' },
            { title: 'Landing Page Design', link: '#' },
            { title: 'Website Redesign & Optimization', link: '#' }
        ],
        'seo-services': [
            { title: 'On-Page SEO', link: '#' },
            { title: 'Off-Page SEO', link: '#' },
            { title: 'Technical SEO', link: '#' },
            { title: 'Local SEO', link: '#' }
        ],
        'paid-advertising': [
            { title: 'Google Ads', link: '#' },
            { title: 'Facebook Ads', link: '#' },
            { title: 'Instagram Ads', link: '#' }
        ],
        'branding-services': [
            { title: 'Logo Design', link: '#' },
            { title: 'Brand Strategy', link: '#' },
            { title: 'Identity Design', link: '#' }
        ],
        'app-development': [
            { title: 'iOS Development', link: '#' },
            { title: 'Android Development', link: '#' },
            { title: 'Hybrid Apps', link: '#' }
        ]
    };
    let servicesSubData = { ...fallbackServicesSubData };

    // Load dynamic services data if available
    const dynamicDataEl = document.getElementById('mobileServicesData');
    if (dynamicDataEl) {
        try {
            const dynamicData = JSON.parse(dynamicDataEl.textContent);
            if (Object.keys(dynamicData).length > 0) {
                Object.keys(dynamicData).forEach(key => {
                    if (Array.isArray(dynamicData[key]) && dynamicData[key].length > 0) {
                        servicesSubData[key] = dynamicData[key];
                    }
                });
            }
        } catch (e) {
            console.error('Error parsing mobile services data', e);
        }
    }

    // --- Toggle Menu Visibility ---
    function openMobileMenu() {
        hamburger.classList.add('active');
        mobileMenuDrawer.classList.add('active');
        if (menuOverlay) menuOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        resetDrillDown(); // Ensure we start at the main layer
    }

    function closeMobileMenu() {
        hamburger.classList.remove('active');
        mobileMenuDrawer.classList.remove('active');
        if (menuOverlay) menuOverlay.classList.remove('active');
        document.body.style.overflow = '';
        setTimeout(resetDrillDown, 300); // Reset after closing animation
    }

    function resetDrillDown() {
        if (mobileMainLayer) mobileMainLayer.classList.remove('drilled');
        if (mobileSubmenuLayer) mobileSubmenuLayer.classList.remove('active');
        if (mobileSubSubmenuLayer) mobileSubSubmenuLayer.classList.remove('active');
    }

    function applyDrillDown(type, link) {
        if (mobileMainLayer) mobileMainLayer.classList.add('drilled');
        if (mobileSubmenuLayer) {
            mobileSubmenuLayer.classList.add('active');
            
            // Switch content based on type
            const typeContents = mobileSubmenuLayer.querySelectorAll('.mobile-submenu-type-content');
            typeContents.forEach(c => {
                if (c.getAttribute('data-type') === type) {
                    c.style.display = 'block';
                } else {
                    c.style.display = 'none';
                }
            });

            // Update title
            const titleEl = mobileSubmenuLayer.querySelector('.mobile-submenu-title');
            if (titleEl) {
                const titleText = type.charAt(0).toUpperCase() + type.slice(1);
                if (link && link !== '#' && link !== 'javascript:void(0);') {
                    titleEl.innerHTML = `<a href="${link}" style="color: inherit; text-decoration: none;">${titleText}</a>`;
                } else {
                    titleEl.innerText = titleText;
                }
            }
        }
    }

    function applySubDrillDown(id, title, link) {
        if (mobileSubSubmenuLayer && subSubContent) {
            const data = servicesSubData[id] || [];
            let html = '<div class="mobile-sub-services-list">';
            if (data.length > 0) {
                data.forEach(item => {
                    html += `<a href="${item.link}" class="mobile-sub-service-item">${item.title}</a>`;
                });
            } else if (link && link !== '#' && link !== 'javascript:void(0);') {
                html += `<a href="${link}" class="mobile-sub-service-item">View ${title}</a>`;
            } else {
                html += '<span class="mobile-sub-service-empty">No sub-services available yet.</span>';
            }
            html += '</div>';
            subSubContent.innerHTML = html;
            
            // Update title
            const titleEl = mobileSubSubmenuLayer.querySelector('.mobile-submenu-title');
            if (titleEl && title) {
                if (link && link !== '#') {
                    titleEl.innerHTML = `<a href="${link}" style="color: inherit; text-decoration: none;">${title}</a>`;
                } else {
                    titleEl.innerText = title;
                }
            }

            mobileSubSubmenuLayer.classList.add('active');
        }
    }

    if (hamburger) {
        hamburger.addEventListener('click', function (e) {
            e.stopPropagation();
            if (mobileMenuDrawer.classList.contains('active')) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });
    }

    if (closeBtn) closeBtn.addEventListener('click', closeMobileMenu);
    if (menuOverlay) menuOverlay.addEventListener('click', closeMobileMenu);
    if (backBtn) backBtn.addEventListener('click', resetDrillDown);
    if (subSubBackBtn) {
        subSubBackBtn.addEventListener('click', () => {
            if (mobileSubSubmenuLayer) mobileSubSubmenuLayer.classList.remove('active');
        });
    }

    // Handle clicks on mobile main services to trigger second level
    document.addEventListener('click', (e) => {
        const titleLink = e.target.closest('.mobile-service-title-link');
        if (titleLink) {
            // Let the link be followed naturally
            return;
        }

        const serviceItem = e.target.closest('.mobile-service-main-item');
        if (serviceItem) {
            const id = serviceItem.getAttribute('data-id');
            const title = serviceItem.getAttribute('data-title');
            const link = serviceItem.getAttribute('data-link');
            applySubDrillDown(id, title, link);
        }
    });

    // --- Accordion & Drill-down Logic ---
    function initMenuInteractions() {
        const menuItems = document.querySelectorAll('.mobile-nav-menu .nav-item > a, .mobile-nav-menu .mobile-nav-item > a');

        menuItems.forEach(link => {
            link.addEventListener('click', function (e) {
                const parentItem = this.parentElement;
                
                // If it's a Mega Menu trigger, use drill-down
                if (parentItem.classList.contains('mega-menu-trigger')) {
                    e.preventDefault();
                    e.stopPropagation();
                    const type = parentItem.getAttribute('data-mega-type') || 'industries';
                    const link = this.getAttribute('href');
                    applyDrillDown(type, link);
                    return;
                }

                // Standard Accordion for regular children
                const subMenu = parentItem.querySelector('.sub-menu');
                if (subMenu) {
                    e.preventDefault();
                    e.stopPropagation();
                    parentItem.classList.toggle('active');
                }
            });
        });
    }

    initMenuInteractions();

    // --- Sticky Header Scroll Class ---
    const header = document.querySelector('.site-header');
    if (header) {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                header.classList.add('is-sticky');
            } else {
                header.classList.remove('is-sticky');
            }
        };

        window.addEventListener('scroll', handleScroll);
        // Initial check on load
        handleScroll();
    }

    // Close menu on window resize (desktop)
    window.addEventListener('resize', function () {
        if (window.innerWidth > 1200) {
            closeMobileMenu();
        }
    });

    // Handle keyboard escape key
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closeMobileMenu();
        }
    });
});
